import React, { type FC } from 'react';
import ErrorInfoCircleImage from '../../assets/img/red-error-info-circle.svg?url';
import { DH } from '../../utils/DataHook';
import { t } from '../../utils/i18n';
import { useTheme } from '../../contexts/Theme';
import { validationErrorI18nKeys } from './validationErrorI18nKeys';
import s from './styles.scss';

interface ErrorMessageProps {
  fieldName: string;
}

export const FieldErrorMessage: FC<ErrorMessageProps> = (props) => {
  const theme = useTheme();

  const errorIcon =
    theme === 'wsr-like' ? (
      <img src={ErrorInfoCircleImage} className={s.fieldErrorMessageIcon} aria-hidden alt="" />
    ) : null;
  return (
    <div id={`${props.fieldName}-error-message`} className={s.fieldErrorMessage} data-hook={DH.Field.ErrorMessage}>
      {errorIcon}
      <label htmlFor={props.fieldName}>{t(validationErrorI18nKeys[props.fieldName])}</label>
    </div>
  );
};
FieldErrorMessage.displayName = 'FieldErrorMessage';
